
import {
    GET_RISKS,
    GET_RISKS_FAIL,
    GET_RISKS_SUCCESS
} from '../types/risk';

export const getRisks = () => {
    return dispatch => {
        dispatch({
            type: GET_RISKS,
        });
    }
};

export const getRisksResponse = (response) => {
    return dispatch => {
        dispatch({
            type: response.status? GET_RISKS_SUCCESS: GET_RISKS_FAIL,
            response
        })
    }
};



// WEBPACK FOOTER //
// ./src/actions/risks.js